module.exports = __webpack_public_path__ + "static/img/5.2d01c90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/5.jpg
// module id = txlm
// module chunks = 1